import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Breed } from '../../../structures/models/breed';
import routes from '../../../utils/routes';
import EditSVG from '../../search/admin-dashboard-tables/assets/EditSVG';
import DateHelper from '../../../utils/DateHelper';

type LocalBreed = Breed & {
  updated_at_timestamp: number,
}

type SortablePopularBreedTableInput = {
  breedList: LocalBreed[];
};

const SortablePopularBreedTable: React.FC<SortablePopularBreedTableInput> = ({
  breedList,
}) => {
  const [sortedBreeds, setSortedBreeds] = useState(breedList);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState(false);

  const onDragStart = (e: React.DragEvent<HTMLTableRowElement>, index: number) => {
    e.dataTransfer.setData('index', index.toString());
  };

  const onDragOver = (e: React.DragEvent<HTMLTableRowElement>) => {
    e.preventDefault();
  };

  const submitOrder = (orderedBreeds: Breed[]) => {
    axios.post(routes.apiBreedBulkSort, {
      breeds: orderedBreeds,
    })
      .then((response) => {
        setSortedBreeds(response.data.breeds);
        setSaved(true);
        setError(false); // Set error to false here
      })
      .catch(() => {
        setSaved(false);
        setError(true);
      });
  };
  const onDrop = (e: React.DragEvent<HTMLTableRowElement>, droppedOnIndex: number) => {
    const draggedIndex = parseInt(e.dataTransfer.getData('index'), 10);

    if (draggedIndex === droppedOnIndex) {
      return;
    }

    const updatedBreeds = [...sortedBreeds];
    const draggedItem = updatedBreeds.splice(draggedIndex, 1)[0];
    updatedBreeds.splice(droppedOnIndex, 0, draggedItem);

    setSortedBreeds(updatedBreeds);
    submitOrder(updatedBreeds);
  };

  return (
    <div className="react-admin-dashboard-table">
      {
        saved && (
          <div className="alert alert-success" role="alert">
            <strong>Success!</strong>
            {' '}
            The order has been saved.
          </div>
        )
      }
      {
        error && (
          <div className="alert alert-danger" role="alert">
            <strong>Error!</strong>
            {' '}
            The order could not be saved.
          </div>
        )
      }
      <div className="admin-dashboard-table-wrapper">
        <table id="admin-dashboard-sortable-breeds-table" className="table table-hover border">
          <thead>
            <tr className="bg-table-header-gray">
              <th>Order</th>
              <th>Name</th>
              <th>Description</th>
              <th>Updated At</th>
              <th>{' '}</th>
            </tr>
          </thead>
          <tbody>
            {
            sortedBreeds.map((breed, index) => (
              <tr
                data-id={breed.id}
                draggable
                key={breed.id}
                onDragOver={onDragOver}
                onDragStart={(e) => onDragStart(e, index)}
                onDrop={(e) => onDrop(e, index)}
              >
                <td>{breed.is_popular_sort_order}</td>
                <td>{breed.name}</td>
                <td>{breed.description}</td>
                <td>
                  {DateHelper.getLocalizedDateTimeFromTimestamp(breed.updated_at_timestamp)
                    .format('MM/DD/YY H:mm:ss')}
                </td>
                <td className="align-middle d-none d-xl-table-cell">
                  <a
                    className="edit btn btn-admin-button-gray d-flex align-items-center"
                    href={routes.adminEditBreed(breed.slug)}
                    aria-label={`Edit breed with name: ${breed.name}.`}
                  >
                    <EditSVG />
                  </a>
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
      </div>
    </div>
  );
};
const elem = document.getElementById('admin-dashboard-sortable-breeds-table');

if (elem) {
  const breedsAttribute = elem.getAttribute('data-breeds');
  const breeds = breedsAttribute ? JSON.parse(breedsAttribute) : null;

  ReactDOM.render(<SortablePopularBreedTable
    breedList={breeds}
  />, elem);
}
